import { OPENING_SESSION_DISPLAY_STATUSES, OPENING_SESSION_ORIGINS } from '@gozoki/api-types'
import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import z from 'zod'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { periods } from '~/components/new/app-ui/period-select'
import { Title } from '~/components/new/app-ui/title'
import { RecordingGrid } from '~/components/routes/pre-authorizations/recording-grid'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/pre-authorizations/$sessionId/recordings')({
  staticData: {
    permission: ['read', 'pre-authorizations.pre-authorizations.session'],
  },
  component: PreAuthorizationRecordingsPage,
  params: {
    parse: z.object({ sessionId: z.coerce.number() }).parse,
  },
  validateSearch: z.object({
    storeId: z.number().optional(),
    status: z.enum(OPENING_SESSION_DISPLAY_STATUSES).optional(),
    origin: z.enum(OPENING_SESSION_ORIGINS).optional(),
    period: z.enum(periods).optional(),
    page: z.number().optional(),
    pageSize: z.number().optional(),
  }),
})
withRoutePermissions(Route)

function PreAuthorizationRecordingsPage() {
  const { sessionId } = Route.useParams()
  const search = Route.useSearch()

  return (
    <>
      <AppHeader>
        <Title>Relecture pré-autorisation</Title>
      </AppHeader>

      <AppContainer>
        <Link
          to="/pre-authorizations"
          search={search}
          className="flex w-fit items-center gap-1 text-sm font-medium text-primary hover:underline"
        >
          <ArrowLeft className="size-4" />
          Retour aux pré-autorisations
        </Link>

        <RecordingGrid sessionId={sessionId} />
      </AppContainer>
    </>
  )
}
